import render from '../common';

import reducer from './rootReducer';
import middleware from './middleware';
import routes from './routes';

render({ routes, reducer, middleware });
